/**
 * Backend placeholder title for a chat that has not been named yet. Must
 * match backend copy (see `deriveOptimisticChatTitle` in
 * `src/hooks/mutation/useMutateCreateChat.ts`, the source of truth this was
 * derived from).
 */
export const BACKEND_PLACEHOLDER_CHAT_TITLE = 'New Chat';

/**
 * Whether a chat title is the backend's untranslated placeholder (or unset).
 * Trimmed and case-insensitive so callers stay aligned even if the backend
 * ever returns the placeholder with different casing or surrounding
 * whitespace.
 */
export const isBackendPlaceholderChatTitle = (
  title: string | null | undefined
): boolean => {
  const trimmed = title?.trim();
  return (
    !trimmed || trimmed.toLowerCase() === BACKEND_PLACEHOLDER_CHAT_TITLE.toLowerCase()
  );
};
